var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseModule } from './../commons/BaseModule';
import Vue from 'vue';
import localForage from "localforage";
var LocalStorageModule = (function (_super) {
    __extends(LocalStorageModule, _super);
    function LocalStorageModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LocalStorageModule.prototype.preInstall = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.store = localForage.createInstance({
                name: 'smartcertificate_storage',
                storeName: 'smartcertificate_store'
            });
            Vue.prototype.$localStorage = _this.store;
            resolve(true);
        });
    };
    LocalStorageModule.prototype.finalizeInstall = function (options) {
        return new Promise(function (resolve, reject) {
            resolve(true);
        });
    };
    LocalStorageModule.prototype.setItem = function (key, value) {
        return this.store.setItem(key, value);
    };
    LocalStorageModule.prototype.getItem = function (key) {
        return this.store.getItem(key);
    };
    return LocalStorageModule;
}(BaseModule));
export default LocalStorageModule;



//////////////////
// WEBPACK FOOTER
// ./src/modules/local-storage/index.ts
// module id = null
// module chunks = 